import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

@Component({
  selector: 'etxe-explore-card-skeleton',
  imports: [NgxSkeletonLoaderComponent],
  templateUrl: './explore-card-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExploreCardSkeletonComponent {
  count = input<number>(6);
  readonly items = computed(() => Array.from({ length: this.count() }, (_, i) => i));
}
